import { useState, useEffect } from 'react';
import { Toaster } from 'sonner';
import { LoginScreen } from '../components/admin/LoginScreen';
import { Dashboard } from '../components/admin/Dashboard';

export function AdminPage() {
  const [creds, setCreds] = useState(null);

  useEffect(() => {
    const stored = sessionStorage.getItem('adminCreds');
    if (stored) {
      setCreds(JSON.parse(stored));
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('adminCreds');
    setCreds(null);
  };

  return (
    <div data-testid="admin-page">
      <Toaster position="top-right" richColors />
      {creds ? (
        <Dashboard creds={creds} onLogout={handleLogout} />
      ) : (
        <LoginScreen onLogin={setCreds} />
      )}
    </div>
  );
}

export default AdminPage;
